import type { IMenu } from '@/types/Data'
import type { IBulkUpdateOrderMenu, IPayloadMenu } from '@/types/Request'
import BaseService from '../BaseService'

export default class MenuServices extends BaseService {
  GetMenuList(TargetLanguageId: string) {
    return this.GET<IMenu[]>(this.PATHS.GET_MENU_LIST, { TargetLanguageId, IsWithReplace: false })
  }

  CreateMenu(data: IPayloadMenu) {
    return this.POST<IMenu>(this.PATHS.CREATE_MENU, data)
  }

  UpdateMenu(data: IPayloadMenu) {
    return this.PUT<IMenu>(this.PATHS.UPDATE_MENU, data)
  }

  DeleteMenu(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_MENU, null, { Id })
  }

  BulkUpdateMenuOrder(data: IBulkUpdateOrderMenu[]) {
    return this.POST<IMenu>(this.PATHS.BULK_UPDATE_MENU_ORDER, { MenuOrders: data })
  }
}
